"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledContainer = exports.MenuStyles = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledIcon = _interopRequireDefault(require("../Icon/StyledIcon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var rcMenuOpenSlideUpIn = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0;transform-origin:0% 0%;transform:scaleY(0);}100%{opacity:1;transform-origin:0% 0%;transform:scaleY(1);}"]);
var rcMenuOpenSlideUpOut = (0, _ykbStyledComponents.keyframes)(["0%{opacity:1;transform-origin:0% 0%;transform:scaleY(1);}100%{opacity:0;transform-origin:0% 0%;transform:scaleY(0);}"]);
var rcMenuOpenZoomIn = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0;transform:scale(0,0);}100%{opacity:1;transform:scale(1,1);}"]);
var rcMenuOpenZoomOut = (0, _ykbStyledComponents.keyframes)(["0%{transform:scale(1,1);}100%{opacity:0;transform:scale(0,0);}"]);

//#region menu styles
var MenuStyles = exports.MenuStyles = (0, _ykbStyledComponents.createGlobalStyle)([".", "{outline:none;margin-bottom:0;padding-left:0;list-style:none;border:1px solid ", ";box-shadow:", ";border-radius:", ";color:", ";}.", "{.icon-span{font-size:", "px;padding-right:5px;vertical-align:middle;}}.", "-hidden{display:none;}.", "-collapse{overflow:hidden;.", "-active{transition:height 0.3s ease-out;}}.", "-item-group-list{margin:0;padding:0;}.", "-item-group-title{color:", ";line-height:1.5em;padding:", ";border-bottom:1px solid ", ";}.", "-item-active,.", "-submenu-active > .", "-submenu-title{background-color:", ";}.", "-item-selected{background-color:", ";transform:translateZ(0);}.", "-submenu-selected{background-color:", ";}.", " li.", "-submenu{padding:0;}.", "-horizontal.", "-sub,.", "-vertical.", "-sub,.", "-vertical-left.", "-sub,.", "-vertical-right.", "-sub{min-width:", ";background-color:", ";margin-top:0;}.", "-item,.", "-submenu-title{margin:0;position:relative;display:block;padding:", ";white-space:nowrap;color:", ";.", "-item-disabled,.", "-submenu-disabled{color:", ";}}.", "-item,.", "-submenu-title{margin:0;position:relative;display:block;padding:", ";white-space:nowrap;}.", "-item-disabled,.", "-submenu-disabled{color:", ";}.", " > .", "-item-divider{height:1px;margin:1px 0;overflow:hidden;padding:0;line-height:0;background-color:", ";}.", "-submenu .", "{background-color:", ";}.", "-submenu-popup{position:absolute;}.", "-submenu-title,.", "-item{svg{width:", "px;height:", "px;margin-right:8px;}}.", "-horizontal{color:", ";background-color:", ";border:none;border-bottom:1px solid ", ";box-shadow:none;> .", "-item,> .", "-submenu > .", "-submenu-title{padding:", ";&:first-child{border-radius:", " ", " 0 0;}&:last-child{border-radius:0 0 ", " ", ";}}.", "-submenu,.", "-item{float:left;border-bottom:2px solid transparent;}.", "-item-active,.", "-submenu-active{border-bottom:2px solid ", ";background-color:", ";color:", ";}&:after{content:'\\20';display:block;height:0;clear:both;}}.", "-vertical,.", "-vertical-left,.", "-vertical-right,.", "-inline{padding:", ";> .", "-item,.", "-submenu > .", "-submenu-title{padding:", ";&:first-child{border-radius:", " ", " 0 0;}&:last-child{border-radius:0 0 ", " ", ";}}", ".expand-icon{display:inline-block;font-style:normal;vertical-align:baseline;text-align:center;text-transform:none;line-height:1;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:absolute;right:", ";top:50%;transform:translatey(-50%);}}.", "-inline{", ".expand-icon{transform:translatey(-50%);transition:transform 0.3s;svg{transform:rotate(0deg);transition:transform 0.3s;}}.", "-submenu-open > .", "-submenu-title{", ".expand-icon{transform:translatey(-50%);svg{transform:rotate(180deg);transition:transform 0.3s;}}}}.", "-vertical.", "-sub,.", "-vertical-left.", "-sub,.", "-vertical-right.", "-sub{padding:0;> .", "-item,.", "-submenu > .", "-submenu-title{padding:", ";}}.", "-sub.", "-inline{padding:0;border:none;border-radius:0;box-shadow:none;> .", "-item,> .", "-submenu > .", "-submenu-title{padding:", ";padding-top:8px;padding-bottom:8px;padding-right:0;}}.", "-open{.", "-slide-up-enter,.", "-slide-up-appear{animation-duration:0.3s;animation-fill-mode:both;transform-origin:0 0;opacity:0;animation-timing-function:cubic-bezier(0.08,0.82,0.17,1);animation-play-state:paused;}.", "-slide-up-leave{animation-duration:0.3s;animation-fill-mode:both;transform-origin:0 0;opacity:1;animation-timing-function:cubic-bezier(0.6,0.04,0.98,0.34);animation-play-state:paused;}.", "-slide-up-enter.", "-slide-up-enter-active,.", "-slide-up-appear.", "-slide-up-appear-active{animation-name:", ";animation-play-state:running;}.", "-slide-up-leave.", "-slide-up-leave-active{animation-name:", ";animation-play-state:running;}}.", "-zoom-enter,.", "-zoom-appear{opacity:0;animation-duration:0.3s;animation-fill-mode:both;transform-origin:0 0;animation-timing-function:cubic-bezier(0.08,0.82,0.17,1);animation-play-state:paused;}.", "-zoom-leave{animation-duration:0.3s;animation-fill-mode:both;transform-origin:0 0;animation-timing-function:cubic-bezier(0.6,0.04,0.98,0.34);animation-play-state:paused;}.", "-zoom-enter.", "-zoom-enter-active,.", "-zoom-appear.", "-zoom-appear-active{animation-name:", ";animation-play-state:running;}.", "-zoom-leave.", "-zoom-leave-active{animation-name:", ";animation-play-state:running;}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.borderColor;
}, function (props) {
  return props.theme.menu.shadow;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.title.color;
}, function (props) {
  return props.theme.menu.title.padding;
}, function (props) {
  return props.theme.menu.title.borderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.active.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.selected.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.selected.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.sub.minWidth;
}, function (props) {
  return props.theme.menu.sub.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.sub.title.padding;
}, function (props) {
  return props.theme.menu.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.disabled.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.sub.title.padding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.disabled.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.divider.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.sub.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.horizontal.color;
}, function (props) {
  return props.theme.menu.horizontal.backgroundColor;
}, function (props) {
  return props.theme.menu.horizontal.borderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.horizontal.padding;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.horizontal.active.borderColor;
}, function (props) {
  return props.theme.menu.horizontal.active.backgroundColor;
}, function (props) {
  return props.theme.menu.horizontal.active.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.vertical.padding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.vertical.titlePadding;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.borderRadius;
}, function (props) {
  return props.theme.menu.borderRadius;
}, _StyledIcon.default, function (props) {
  return props.theme.menu.vertical.arrowRight;
}, function (props) {
  return props.prefixCls;
}, _StyledIcon.default, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, _StyledIcon.default, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.sub.title.padding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.menu.vertical.titlePadding;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcMenuOpenSlideUpIn, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcMenuOpenSlideUpOut, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcMenuOpenZoomIn, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcMenuOpenZoomOut);
//#endregion

var MemoizedMenuStyles = /*#__PURE__*/_react.default.memo(MenuStyles, function (previousProps, nextProps) {
  return previousProps.prefixCls === nextProps.prefixCls;
});
var Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    withoutStyle = _ref.withoutStyle;
  // last classname what we need
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !withoutStyle && /*#__PURE__*/_react.default.createElement(MemoizedMenuStyles, {
    theme: theme,
    prefixCls: prefix
  }), children(prefix));
};
var StyledContainer = exports.StyledContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-9we6ln-0"
})([""]);